exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accountPage-main {\n  width: 100%;\n  padding: 16px 0px 48px 0px;\n  margin: 0px 0px 32px 0px; }\n\n.accountPage-titleContainer {\n  display: flex;\n  justify-content: center;\n  width: 70%;\n  margin: 0 auto; }\n", ""]);

// exports
